module.exports = __webpack_public_path__ + "static/index/img/baikal-601.06d35b9c.jpg";